import React from 'react';
import { identifyComponent } from '../../util';
import { ButtonLink, ButtonLinkProps } from './ButtonLink';
import { ExternalLink, ExternalLinkProps } from './ExternalLink';
import { InternalLink, InternalLinkProps } from './InternalLink';

export type InlineLinkProps = InternalLinkProps | ExternalLinkProps | ButtonLinkProps;

/**
 * InlineLink is a component to handle all link-like elements including React Router
 * Links and buttons with onClick handlers that simply look like links.
 */
export const InlineLink = React.forwardRef<HTMLElement, InlineLinkProps>((props, ref) => {
  if (props.to !== undefined) {
    return (
      <InternalLink
        data-component="InlineLink"
        {...props}
        {...identifyComponent('inline-link', props)}
      />
    );
  }

  if (props.href !== undefined) {
    return (
      <ExternalLink
        data-component="InlineLink"
        {...props}
        {...identifyComponent('inline-link', props)}
      />
    );
  }

  return (
    <ButtonLink
      data-component="InlineLink"
      ref={ref}
      {...props}
      {...identifyComponent('inline-link', props)}
    />
  );
});

InlineLink.displayName = 'InlineLink';
